import React from 'react';
import {Helmet} from 'react-helmet-async';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import Box from 'shared/ui/Box/Box';
import LoaderCentered from 'shared/ui/LoaderCentered/LoaderCentered';
import useDomainMonitorDetails from 'features/domain/model/useDomainMonitorDetails';

import DomainMonitorHeader from './DomainMonitorHeader/DomainMonitorHeader';
import DomainMonitorChecksSummary from './DomainMonitorChecksSummary/DomainMonitorChecksSummary';
import DomainMonitorIncidents from './DomainMonitorIncidents/DomainMonitorIncidents';

import styles from './DomainMonitorDetails.module.scss';

const DomainMonitorDetails: React.FC = () => {
    const {domainMonitor, isLoading, isMobile, backgroundKind} = useDomainMonitorDetails();

    if (isLoading || !domainMonitor) {
        return <LoaderCentered active/>;
    }

    const backgroundClass = {
        en: styles.enContainer,
        ok: styles.okBackground,
        paused: styles.pausedBackground,
    }[backgroundKind];

    return (
        <>
            {
                isMobile &&
                <div className={styles.containerHeader}>
                    <DomainMonitorHeader domainMonitor={domainMonitor}/>
                </div>
            }

            <Box className={cn(styles.container, backgroundClass)}>
                <Helmet>
                    <title>{`${domainMonitor.domain_human_readable} | ${t`Overseer`}`}</title>
                </Helmet>

                {
                    !isMobile &&
                    <>
                        <DomainMonitorHeader domainMonitor={domainMonitor}/>
                        <span className={styles.line}/>
                    </>
                }
                <DomainMonitorChecksSummary domainMonitor={domainMonitor}/>
            </Box>

            <DomainMonitorIncidents domainMonitor={domainMonitor}/>
        </>
    );
};

export default DomainMonitorDetails;
